export const body = {
    paddingRight: "30px",
    paddingTop: "20px"
};

export const textColumns = {
    display: "flex",
    flex: "1",
    flexDirection: "row",
    alignItems: "center",
    columnGap: "10px",
    // border: "1px solid black",
    height: "100%"
};
